import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Building20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M16.6672 15.5999H15.6005V5.83325C15.6005 4.45254 14.4812 3.33325 13.1005 3.33325H7.43386C6.05314 3.33325 4.93385 4.45254 4.93385 5.83325V15.5999H3.86719C3.86719 15.5999 3.86719 15.8389 3.86719 16.1333C3.86719 16.4277 3.86719 16.6666 3.86719 16.6666H16.6672C16.6672 16.6666 16.6672 16.4277 16.6672 16.1333C16.6672 15.8389 16.6672 15.5999 16.6672 15.5999ZM11.6894 5.64436H12.4005C12.6949 5.64436 12.9339 5.8833 12.9339 6.1777C12.9339 6.4721 12.6949 6.71103 12.4005 6.71103H11.6894C11.395 6.71103 11.1561 6.4721 11.1561 6.1777C11.1561 5.8833 11.395 5.64436 11.6894 5.64436ZM11.6894 7.7777H12.4005C12.6949 7.7777 12.9339 8.01663 12.9339 8.31103C12.9339 8.60543 12.6949 8.84436 12.4005 8.84436H11.6894C11.395 8.84436 11.1561 8.60543 11.1561 8.31103C11.1561 8.01663 11.395 7.7777 11.6894 7.7777ZM11.6894 9.91103H12.4005C12.6949 9.91103 12.9339 10.15 12.9339 10.4444C12.9339 10.7388 12.6949 10.9777 12.4005 10.9777H11.6894C11.395 10.9777 11.1561 10.7388 11.1561 10.4444C11.1561 10.15 11.395 9.91103 11.6894 9.91103ZM8.13385 5.64436H8.84496C9.13937 5.64436 9.3783 5.8833 9.3783 6.1777C9.3783 6.4721 9.13937 6.71103 8.84496 6.71103H8.13385C7.83945 6.71103 7.60052 6.4721 7.60052 6.1777C7.60052 5.8833 7.83945 5.64436 8.13385 5.64436ZM8.13385 7.7777H8.84496C9.13937 7.7777 9.3783 8.01663 9.3783 8.31103C9.3783 8.60543 9.13937 8.84436 8.84496 8.84436H8.13385C7.83945 8.84436 7.60052 8.60543 7.60052 8.31103C7.60052 8.01663 7.83945 7.7777 8.13385 7.7777ZM8.13385 9.91103H8.84496C9.13937 9.91103 9.3783 10.15 9.3783 10.4444C9.3783 10.7388 9.13937 10.9777 8.84496 10.9777H8.13385C7.83945 10.9777 7.60052 10.7388 7.60052 10.4444C7.60052 10.15 7.83945 9.91103 8.13385 9.91103ZM8.66719 13.6444C8.66719 12.9333 9.02274 12.5777 9.73385 12.5777H10.8005C11.5116 12.5777 11.8672 12.9333 11.8672 13.6444V15.5999H8.66719V13.6444Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
